// Float-right (nằm ngoài .MS__outer nên không tự scale theo trang):
// - Đọc tỉ lệ scale của #MS__wrapper (libraryMainsite scaleRoot áp) rồi gán vào
//   biến --fr-scale để float_right scale y hệt trang.
// - Khi load xong gắn .is-in để cụm trượt vào (CSS lo animation).
window.addEventListener("load", function () {
  var el = document.getElementById("libraryMainsite-t-float_right");
  if (!el) return;
  var wrap = document.getElementById("MS__wrapper");

  function syncScale() {
    var k = 1;
    if (wrap) {
      var t = getComputedStyle(wrap).transform;
      var m = t && t.match(/matrix\(([^)]+)\)/);
      if (m) {
        var v = parseFloat(m[1].split(",")[0]);
        if (v > 0) k = v;
      }
    }
    el.style.setProperty("--fr-scale", k);
  }

  syncScale();
  // Đọc lại vài lần phòng khi lib set scale trễ sau load
  setTimeout(syncScale, 300);
  setTimeout(syncScale, 800);
  window.addEventListener("resize", syncScale);

  // delay nhỏ để trình duyệt vẽ trạng thái ban đầu trước khi chạy transition
  setTimeout(function () {
    el.classList.add("is-in");
  }, 200);
});
